import { useState, useEffect, useMemo } from 'react';
import LineChart from "../../components/charts/LineChart";
import { Box, Typography, Paper } from "@mui/material";


const ChartComponent = ({ data, loading, title = null, threshold, onExport = false }) => {
  // Извлечение данных для графика
  const processedData = useMemo(() => {
    
    if (!data || data.length === 0) {
      console.log('No data or empty data array');
      return {
        x: [],
        y: [],
        title: title || 'Средний балл по дате',
        xTitle: 'Дата',
        yTitle: 'Средний балл (%)',
        color: '#4dc9f6'
      };
    }

    // Группировка данных по дате оценки
    const scoresByDate = {};
    
    data.forEach((item, index) => {
      
      if (item.assessment && item.sound && item.sound.date_sound) {
        // Используем date_sound из sound для группировки
        const date = item.sound.date_sound.split('T')[0];
        const score = item.assessment.total_score * 100; // Перевод в проценты
        if (!scoresByDate[date]) {
          scoresByDate[date] = [];
        }
        scoresByDate[date].push(score);
      } else {
        console.log(`Item ${index} skipped - missing assessment or assessment_date`);
      }
    });

    // Сортировка дат по возрастанию
    const sortedDates = Object.keys(scoresByDate).sort();

    // Вычисление среднего балла для каждой даты
    const averageScores = sortedDates.map(date => {
      const scores = scoresByDate[date];
      const average = scores.reduce((sum, score) => sum + score, 0) / scores.length;
      return average;
    });

    return {
      x: sortedDates,
      y: averageScores,
      title: title || 'Средний балл по дате',
      xTitle: 'Дата',
      yTitle: 'Средний балл (%)',
      color: '#4dc9f6',
      series: [
        {
          x: sortedDates,
          y: averageScores,
          name: 'Средний балл (%)',
          color: '#4dc9f6',
          width: 3,
          markerSize: 8
        }
      ]
    };
  }, [data, title]);


  console.log("processedData: ", processedData);
  if (loading) {
    return (
      <Box sx={{ height: '100%', width: '100%', mt: 4 }}>
        <Paper sx={{ p: 2, height: '100%', width: '100%' }}>
          <Typography variant="body1" color="text.secondary" sx={{ mt: 2, textAlign: 'center' }}>
            Загрузка...
          </Typography>
        </Paper>
      </Box>
    );
  }

  return (
    <>
      {processedData.x && processedData.x.length > 0 && (
        <Box sx={{ height: '100%', width: '100%', mt: 4 }}>
          <Paper sx={{ p: 2, height: '100%', width: '100%' }}>
            <Typography variant="h6" gutterBottom>
              {title || 'Средний балл по дате'}
            </Typography>
            <Box sx={{ height: '350px', width: '100%' }}>
              <LineChart
                data={processedData}
                threshold={threshold}
                onExport={onExport}
              />
            </Box>
          </Paper>
        </Box>
      )}

      {(!processedData.x || processedData.x.length === 0) && (
        <Box sx={{ height: '100%', width: '100%', mt: 4 }}>
          <Paper sx={{ p: 2, height: '100%', width: '100%' }}>
            <Typography variant="body1" color="text.secondary" sx={{ mt: 2, textAlign: 'center' }}>
              Нет данных для отображения графика
            </Typography>
          </Paper>
        </Box>
      )}
    </>
  );
};

export default ChartComponent;